import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Toast, Modal, Alert, Tab, Tabs, Col } from 'react-bootstrap';
import api from '../../seller-apis/api';

import {
  negotiationReq,
  orderRevoke,
  filterOrders,
  pdetailData
} from '../../seller-apis/apidataField';

import PaginationCom from '../common/Pagination';
import ConfirmationModal from '../common/ConfirmationModal';
import Popup from '../common/Popup';
import Myalert from '../common/Myalert';
import TrackOrderPopup from '../common/TrackOrder-Popup';
import '../order.css';
import OrderCardWeb from '../common/OrderCardWeb';
import { useAlert } from 'react-alert';
import { useOrderDateAlert, resetOrderDateFilter, resolveOrderDateRange } from './useOrderDateAlert';
import OrderSKUSearch from '../common/ProductSearch/OrderSKUSearch';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { resetPackages, setInitialPackages, setReferencePackage } from '../../Actions/PackageWeight';
import { packagesCmtoFt, packagesFttoCm } from '../../utilities/conversion';
import variables from '../../Variables.json'
import WeightComponent from '../common/WeightComponent';
import { arePackagesEqual, checkIsPkgMediaNotPresent, sanitizePkgImages } from '../../utilities/packages';
import axios from 'axios';
import HSNModal from '../common/HSNModal';
import MainLoader from '../common/Loader/PageLoader';
var dateFromWeb = moment().subtract(30, 'days').format('YYYY-MM-DD');
var dateToWeb = moment().format('YYYY-MM-DD');
var datesWeb;

var globalFilter = {
  "pageNo": 1,
  "statusFilter": ["ASSIGN", "DOWNLOAD", "REVOKED", "CANCEL", "DELIVERED", "PICKED", "Lost", "Partially delivered/Lost", "Partially delivered/RTO"],
  "dates": {

  }
};
function AllOrders() {
  const stateData = useSelector(state => state?.ActionReducer);//SL-923
  var outerdiv;
  var loaderDiv;
  const alert = useAlert()
  const showOrderDateAlert = useOrderDateAlert(alert)
  // Size states

  const [currView, setcurrView] = useState();


  const [revokedOrd, setrevokedOrd] = useState([]);
  const [newOrdersList, setnewOrdersList] = useState([]);
  const [ennewloader, setennewloader] = useState("block");
  const [negotiationRequests, setnegotiationRequests] = useState([]);
  const [newRecords, setnewRecords] = useState();

  const [selectedOrder, setSelectedOrder] = useState();


  // Web states

  const [allOrders, setallOrders] = useState([]);
  const [allRecords, setallRecords] = useState(1);
  const [webFiltCurr, setwebFiltCurr] = useState();
  const [speechRes, setspeechRes] = useState();

  // Pagination related

  const [selectedPage, setSelectedPage] = useState(1);



  // Sort Filter States
  // const [pickedSort, setpickedSort] = useState();
  // History
  const [sortHistdatefrom, setHistsortdatefrom] = useState();
  const [sortHistdateto, setHistsortdateto] = useState();

  // Alert related states

  const [alertshow, setalertShow] = useState(false)
  const [alertMessage, setalertMessage] = useState();
  const [alertType, setalertType] = useState();


  // Confirmation related
  const [confirmationState, setconfirmationState] = useState(false)
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [confirmationFor, setconfirmationFor] = useState();
  const [negotiateState, setnegotiateState] = useState();
  const [confirmationType, setconfirmationType] = useState();
  const [selectedOrdername, setSelectedOrdername] = useState();
  // Toast

  const [showToast, setshowToast] = useState(false)
  const [toastmsg, setToastmsg] = useState("")
  const [compforPaginationweb, setcompforPaginationweb] = useState("allOrdersWeb");


  // Track order Popup

  const [selectedtrackOrder, setselectedtrackOrder] = useState(0);
  const [selectedTrackwithin, setselectedTrackwithin] = useState(0)

  //Product Detail Popup

  const [productDetail, setproductDetail] = useState([
    {
      "description": undefined,
      "sdescription": undefined,
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [defUrl, setdefUrl] = useState();
  // Web filter related states

  const [addressName, setAddressName] = useState(undefined)
  const [orderId, setOrderId] = useState(undefined);
  const [orderName, setorderName] = useState(undefined);
  const [currInput, setcurrInput] = useState([]);
  const [sortdatewebFilt, setsortdatewebFilt] = useState("new");
  const [isPopupTrackVisWeb, setisPopupTrackVisWeb] = useState("none");
  const [selectedtrackOrderWeb, setselectedtrackOrderWeb] = useState(0);
  const [detailPPrice, setdetailPPrice] = useState("");
  const [currwebFilt, setcurrwebFilt] = useState();
  const [minValDate, setMinValDate] = useState("")
  const [searchType, setSearchType] = useState("Product Name");

  const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")
  // sl -712
  const [verifyManifestPopup, setVerifyManifestPopup] = useState(false);
  const [currentClickedOrder, setCurrentClickedOrder] = useState(null);
  const [currentStep, setCurrentStep] = useState(0)
  const [tpDisabled, setTpDisabled] = useState(true)
  const [stockDisabled, setStockDisabled] = useState(true)
  const [verTrPrice, setVerTrPrice] = useState(null)
  const [currentStock, setCurrentStock] = useState(null)
  const [clickedProDets, setClickedProDets] = useState()
  const [weightChangeStatus, setWeightChangeStatus] = useState("")
  const { packages, initialPackages, dimensionUnit } = useSelector(state => state.packageReducer)
  const [acceptPackageSelected, setAcceptPackageSelected] = useState(false);
  const [rejectPackageSelected, setRejectPackageSelected] = useState(false)
  const dispatch = useDispatch()
  //SL-675
  const [totalRcordId, setTotalReordId] = useState([]);
  // l1-2319 (2-9-25)
  const [showHSNModal, setShowHSNModal] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  //<Start-Here> Track button Issue | Ticket : SL-950
  const [selectedTransitDetail, setSelectedTransitDetail] = useState([]);
  const [selectedPopupId, setSelectedPopupId] = useState(null);
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // skip first render
      return;
    }

    if (isPopupTrackVisWeb == "none")
      setpopupVisibilitytrackWeb(true);
  }, [selectedTransitDetail]);
  //</End-Here> Track button Issue | Ticket : SL-950

  const handleHSNModalOpen = (product) => {
    setShowHSNModal(true);
    setCurrentProduct(product);
  }
  const handleHSNModalClose = () => {
    setShowHSNModal(false);
    setCurrentProduct(null);
  }
  const handleHSNModalSave = async ({ productId, hsnCode, gstRate }) => {
    let data = {
      _id: productId,
      HSN: hsnCode,
      taxClass: gstRate
    }
    try {
      let res = await api.product.addToExProduct(data)
      if (res.message === "product updated" || res.message === "product added") {
        alert.success("HSN Updated Successfully!");
        getOrders()
      }
      else {
        alert.info(res.message);
      }
    }
    catch (err) {
      alert.info("Failed to update HSN");
      console.log(err);
    }
    finally {
      handleHSNModalClose();
    }
  }

  useEffect(() => {
    const { from, to } = resetOrderDateFilter();
    dateFromWeb = from;
    dateToWeb = to;
    setHistsortdatefrom(from);
    setHistsortdateto(to);
    setselectedTrackwithin(0)
    setselectedtrackOrder(0)
    setselectedtrackOrderWeb(0)
    setSelectedPage(1)
    globalFilter = {
      "pageNo": 1,
      "statusFilter": ["ASSIGN", "DOWNLOAD", "REVOKED", "CANCEL", "DELIVERED", "PICKED", "Lost", "Partially delivered/Lost", "Partially delivered/RTO"],
      "dates": {

      }
    };
    if (dateFromWeb === undefined || dateToWeb === undefined || dateFromWeb === "" || dateToWeb === "") {
      showOrderDateAlert("please select both date", "show");
      return false;
    }
    if (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !== "") {
      let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if (daydiffer > 30) {
        showOrderDateAlert("Date range cannot be more than 30 days.")
        return 0;
      }
      globalFilter.dates = {
        "from-updatedAt": dateFromWeb + 'T00:00:00',
        "to-updatedAt": dateToWeb + 'T23:59:59'
      }
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.productId.productName": orderName,
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.vendorDetails.addrName": addressName
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "orderId": orderId
    }
    applyLoader()
    if (orderId !== undefined || orderName !== undefined || addressName !== undefined || (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !== "")) {
      setremoveFilterClass("invent_remove_filter_btn_active")
    }
    //SL-675
    globalFilter["productId"] = totalRcordId.length == 0 ? true : false;
    api.order?.orders(filterOrders(globalFilter)).then((res) => {
      removeLoader()
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      if (totalRcordId.length == 0) {//SL-675
        setTotalReordId(res?.productId);
        globalFilter["productId"] = false;
      }
    }).catch(err => {
      removeLoader()
      console.log(err)
    })

  }, [])


  useEffect(() => {
    if (addressName === "" || addressName === null) {
      setAddressName(undefined)
    }
  }, [addressName])


  useEffect(() => {
    if (orderId === "" || orderId === null) {
      setOrderId(undefined)
      if (globalFilter?.orderFilter?.orderId){
        applyLoader();
        delete globalFilter.orderFilter.orderId;
        globalFilter.pageNo = 1;
        setSelectedPage(1)
        getOrders()
      }
    }
  }, [orderId])


  useEffect(() => {
    if (orderName === "" || orderName === null) {
      setorderName(undefined)
    }
  }, [orderName])

  // sl -712
  useEffect(() => {
    if (!verifyManifestPopup) {
      setAcceptPackageSelected(false)
      setRejectPackageSelected(false)
      dispatch(resetPackages())
      setTpDisabled(true)
      setStockDisabled(true)
      setCurrentStock(null)
      setVerTrPrice(null)
      setCurrentStep(1)
    }
  }, [verifyManifestPopup])


  // Order Picked
  function productPicked(id, status, pname) {
    if (status === "ASSIGN") {
      setshowToast(true)
    }
    else if (status === "DOWNLOAD") {
      setSelectedOrder(id)
      setSelectedOrdername(pname)
      setmsgConfirmation("Is product picked up by courier boy?")
      setconfirmationState(true)
    }
  }
  // Manifest Download Confirmation

  function isManifestDownloaded(res) {
    let loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
    if (res === "yes") {
      setTimeout(() => {
        setennewloader("flex");
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => {
          console.log(err)
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        })

      }, 500);
    }
  }


  // Confirmation Modal

  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false)
    }
  }
  function responseconfirmation(response, id) {
    let data = {
      "_id": id,
      "status": "PICKED"
    }
    if (response === "yes") {
      setconfirmationState(false)
      api.order?.updateOrder(data).then((res) => {
        let filterData = {
          "pageNo": selectedPage,
        }

        setalertType("lightgreen")
        setalertMessage("Order status updated");
        setalertShow(true)

        setTimeout(() => {
          setalertShow(false)
        }, 3500);
        setTimeout(() => {
          api.order?.orders(filterOrders(globalFilter)).then((res) => {

            setnewOrdersList(res.data)
            setnewRecords(res.totalRecords)
          }).catch(err => {
            console.log(err)
          })
        }, 500);
      }).catch((err) => {
        setalertType("red")
        setalertMessage("Failed");
        setalertShow(true)
        setTimeout(() => {
          setalertShow(false)
        }, 3500);
        console.log(err)
      })
    }
  }


  // Negotiation confirmation related

  function responseConfirmNegotiate(ans, id) {
    let filterData = {
      "pageNo": selectedPage
    }


    if (ans === "yes") {
      setconfirmationState(false)
      if (negotiateState === "accept") {
        let data = {
          "_id": id,
          "status": "APPROVED"
        }
        api.order?.updateOrder((data)).then((res) => {

          setalertMessage("Offer accepted")
          setalertType("lightgreen")
          setalertShow(true)
          api.order?.orders(negotiationReq(filterData)).then((response) => {
            setnegotiationRequests(response.data)
          }).catch(err => {
            console.log(err)
          })
          setTimeout(() => {
            setalertShow(false)
          }, 3500);
        }).catch((err) => {
          console.log(err)
        })
      }
      else if (negotiateState === "reject") {
        let data = {
          "_id": id,
          "status": "DISAPPROVED"
        }
        api.order?.updateOrder((data)).then((res) => {

          setalertMessage("Offer rejected")
          setalertShow(true)
          setalertType("lightgreen")
          api.order?.orders(negotiationReq(filterData)).then((response) => {
            setnegotiationRequests(response.data)
          }).catch(err => {
            console.log(err)
          })
          setTimeout(() => {
            setalertShow(false)
          }, 3500);
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }

  //   Popup related functions
  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }

  function setpopupVisibilitytrackWeb(e) {
    if (e) {
      setisPopupTrackVisWeb("block")
    }
    else {
      setisPopupTrackVisWeb("none")
    }
  }


  function trackPopupWeb(e, trackNo, docketNo) {
    setselectedtrackOrderWeb(e)
    setselectedTrackwithin(trackNo)

  }

  function downloadManifestToast() {
    setToastmsg("Manifest not yet generated, Please try after sometime.")
    setshowToast(true)
  }


  function checkevent(e, name, selectedAddress = null) {//SL-923
    if (e.keyCode === 13) {
      let loaderDiv = document.getElementById("enNewLoader");

      if (name === "id" && orderId !== "" && orderId !== undefined) {
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        globalFilter.pageNo = 1
        globalFilter.orderFilter = {
          ...globalFilter.orderFilter,
          "orderId": orderId
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          console.log(res)
          setallOrders(res.data)
          setallRecords(res.totalRecords);
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => console.log(err));
      }
      else if (name === "name" && orderName !== "" && orderName !== undefined) {
        setSelectedPage(1)
        let ordersearchFilter = searchType != 'sku' ? { "products.productId._id": orderName } : { "products.productId._id": orderName };
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        setcompforPaginationweb("webFilt")
        globalFilter.pageNo = 1
        globalFilter.orderFilter = {
          // ...globalFilter.orderFilter,
          ...ordersearchFilter
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          console.log(res)
          setallOrders(res.data)
          setallRecords(res.totalRecords);
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => console.log(err));
      }
      else if (name === "address" /*&& addressName !== "" && addressName !== undefined*/) {//SL-923
        setSelectedPage(1)
        console.log("fjh")
        setcompforPaginationweb("allOrdersWeb")
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        globalFilter.pageNo = 1;
        globalFilter.orderFilter = {
          ...globalFilter.orderFilter,
          "products.vendorDetails.addrName": selectedAddress //addressName // SL-923
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => console.log(err));
      }
    }
  }


  // Popup showing detail
  function detail(data, price) {
    setdetailPPrice(price)
    console.log(data)
    if (data && data[0] === undefined) {
      setproductDetail(
        [
          {
            "description": "No details available",
            "sdescription": "No short description",
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
          }
        ]
      )
    }
    else {
      setproductDetail(data)
    }
  }

  // Pagination

  function paginate(data) {
    let loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
    setselectedTrackwithin(0)
    setselectedtrackOrder(0)
    setselectedtrackOrderWeb(0)
    globalFilter.pageNo = data.number
    setSelectedPage(data.number)
    setennewloader("flex");
    // New Orders
    api.order?.orders(filterOrders(globalFilter)).then((res) => {
      setallOrders(res.data)
      setennewloader("none")
      loaderDiv.classList.remove("loader-bt");
    }).catch(err => {
      console.log(err)
      loaderDiv.classList.remove("loader-bt");
      setennewloader("none")
    })

  }



  function setstatusfilterWeb(e) {
    applyLoader()
    setSelectedPage(1)
    setcurrwebFilt(e);
    switch (e) {
      case "1":
        globalFilter.pageNo = 1
        globalFilter.statusFilter = ["ASSIGN"]
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res => {
          console.log(res.data)
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("webAssi");
          setcurrInput("ASSIGN")
          removeLoader()
        })).catch(err => console.log(err))
        break;
      case "2":
        globalFilter.pageNo = 1
        globalFilter.statusFilter = ["DOWNLOAD"]
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res => {
          removeLoader()
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("webDown");
          setcurrInput("DOWNLOAD")
        })).catch(err => console.log(err))
        break;
      case "3":
        globalFilter.pageNo = 1
        globalFilter.statusFilter = ["CANCEL"]
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res => {
          removeLoader()
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("webCanc");
          setcurrInput("CANCEL")

        })).catch(err => console.log(err))
        break;
      case "4":
        globalFilter.pageNo = 1
        globalFilter.statusFilter = ["PICKED"]
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res => {
          removeLoader()
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("webShip");
          setcurrInput("PICKED")
        })).catch(err => console.log(err))
        break;
      case "5":
        globalFilter.pageNo = 1
        globalFilter.statusFilter = ["DELIVERED"]
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res => {
          removeLoader()
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("webDeli");
          setcurrInput("DELIVERED")
        })).catch(err => console.log(err))
        break;
      case "6":
        globalFilter.pageNo = 1
        globalFilter.statusFilter = ["REVOKED"]
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res => {
          removeLoader()
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("webRevo");
          setcurrInput("REVOKED")
        })).catch(err => console.log(err))
        break;
      case "7":
        globalFilter.pageNo = 1
        globalFilter.statusFilter = ["Partially delivered/RTO"]
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res => {
          removeLoader()
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("webPartDeliRTO");
          setcurrInput("Partially delivered/RTO")
        })).catch(err => console.log(err))
        break;
      case "8":
        globalFilter.pageNo = 1
        globalFilter.statusFilter = ["Partially delivered/Lost"]
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res => {
          removeLoader()
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("webPartDeliLost");
          setcurrInput("Partially delivered/Lost'")
        })).catch(err => console.log(err))
        break;
      case "9":
        globalFilter.pageNo = 1
        globalFilter.statusFilter = ["Lost"]
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order?.orders(filterOrders(globalFilter)).then((res => {
          removeLoader()
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("webLost");
          setcurrInput("Lost")
        })).catch(err => console.log(err))
        break;
      default:
        globalFilter.pageNo = 1
        removeLoader()
        globalFilter.statusFilter = ["ASSIGN", "DOWNLOAD", "REVOKED", "CANCEL", "DELIVERED", "PICKED", "Lost", "Partially delivered/Lost", "Partially delivered/RTO"]
        api.order?.orders(filterOrders(globalFilter)).then((res) => {
          setdefUrl(res.data[0].order?.products[0].productId.urlKey)
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setcompforPaginationweb("allOrdersWeb")
        }).catch(err => {
          console.log(err)
        })
    }
  }



  function setdateweb(e, type) {
    const { from, to } = resolveOrderDateRange(type, e.target.value, dateFromWeb, dateToWeb);
    dateFromWeb = from;
    dateToWeb = to;
    setHistsortdatefrom(from);
    setHistsortdateto(to);
  }


  // Revoke update

  function revCheck(status) {
    console.log(status)
    if (status === "success") {
      setalertMessage("Updated")
      setalertType("lightgreen")
      setalertShow(true)

      api.order?.orders(orderRevoke()).then((res) => {
        setrevokedOrd(res.data)
      }).catch((err) => {
        console.log(err)
      })
    }
    else {
      setalertMessage("Failed")
      setalertType("red")
      setalertShow(true)
    }
    setTimeout(() => {
      setalertShow(false)
    }, 3000);
  }



  // Function to close all popups opened

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key === "Esc" || evt.key === "Escape") {
      setconfirmationState(false)
      setisPopupTrackVisWeb("none")
      setisDetailPopupVis("none")
    }
  };


  function applyLoader() {
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setennewloader("none")
  }

  function clearFilters() {
    applyLoader()
    setcompforPaginationweb("allOrdersWeb")
    globalFilter = {
      "pageNo": 1,
      "statusFilter": ["ASSIGN", "DOWNLOAD", "REVOKED", "CANCEL", "DELIVERED", "PICKED", "Lost", "Partially delivered/Lost", "Partially delivered/RTO"],
      "dates": {

      }
    }
    setcurrwebFilt(0)
    setorderName("")
    setOrderId("")
    setAddressName("")
    setHistsortdatefrom("")
    setHistsortdateto("")
    dateFromWeb = ""
    dateToWeb = ""
    setSelectedPage(1)
    setselectedTrackwithin(0)
    setselectedtrackOrder(0)
    setselectedtrackOrderWeb(0)
    api.order?.orders(filterOrders(globalFilter)).then((res) => {
      console.log(res)
      removeLoader()
      setremoveFilterClass("invent_remove_filter_btn")
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      setennewloader("none")
    }).catch(err => {
      setennewloader("none")
      console.log(err)
    })

  }

  function applyFilter() {
    setselectedTrackwithin(0)
    setselectedtrackOrder(0)
    setselectedtrackOrderWeb(0)
    setSelectedPage(1)
    globalFilter.pageNo = 1
    if (dateFromWeb === undefined || dateToWeb === undefined || dateFromWeb === "" || dateToWeb === "") {
      showOrderDateAlert("please select both date", "show");
      return false;
    }
    if (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !== "") {
      let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if (daydiffer > 30) {
        showOrderDateAlert("Date range cannot be more than 30 days.")
        return 0;
      }
      globalFilter.dates = {
        "from-updatedAt": dateFromWeb + 'T00:00:00',
        "to-updatedAt": dateToWeb + 'T23:59:59'
      }
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.productId.productName": orderName,
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.vendorDetails.addrName": addressName
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "orderId": orderId
    }
    applyLoader()
    if (orderId !== undefined || orderName !== undefined || addressName !== undefined || (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !== "")) {
      setremoveFilterClass("invent_remove_filter_btn_active")
    }
    api.order?.orders(filterOrders(globalFilter)).then((res) => {
      removeLoader()
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
    }).catch(err => {
      removeLoader()
      console.log(err)
    })
  }

  const getOrders = () => {
    try {
      api.order?.orders(filterOrders(globalFilter)).then((res) => {
        removeLoader()
        setdefUrl("manual-mandava-weeder")
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        throw new Error(err)
      })
    } catch (err) {
      removeLoader()
      console.log(err)
    }
  }

  const filterSearch = (data) => {
    //setorderName(data.data);
    //setSearchType(data.type)
    applyLoader();
    globalFilter['filters'] = { ...globalFilter.filters, "product-objectId": data.data }
    if (globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    //Search Issue on Other than 1st Page SL-698 and SL-675
    globalFilter.pageNo = 1;
    setSelectedPage(1)
    api.order?.orders(filterOrders(globalFilter))
      .then((res) => {
        removeLoader()
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        removeLoader()
        console.log(err)
      })
    if (globalFilter?.filters && globalFilter['filters']['product-objectId'])
      delete globalFilter['filters']['product-objectId'];
  }

  useEffect(() => {
    if (orderName !== "" && orderName !== null && orderName !== undefined) {
      checkevent({ "keyCode": 13 }, "name");
    }
  }, [orderName])

  // sl-712
  // sachin
  const manifestDetailsVerify = (index, step = null) => {
    setCurrentClickedOrder(allOrders[index])
    let data = {
      pId: allOrders[index].product,
    };
    if (step !== null) setCurrentStep(1)
    api.product.productsRetrieveall(pdetailData(data)).then((res) => {
      setClickedProDets(res?.products[0])
      if (res?.products[0]?.vendors?.[0]?.combination.length > 0) {
        let comb = res?.products[0]?.vendors?.[0]?.combination.filter((item) => item?.url === allOrders[index].order?.products[0]?.selSubPrd?.url)
        setVerTrPrice(comb[0]?.purchase_price)
        setCurrentStock(comb[0]?.stock)
        res.products[0].pkgs.map((item1, indexx) => {
          if (item1.url === comb[0].url) {
            setWeightChangeStatus(comb[0]?.sellerWeightChangeSts)
            if (comb[0]?.sellerWeightChangeSts === "T_PENDING") {
              fetchPendingWeightPackages(allOrders[index].product, comb[0].url)
            }
            else {
              // if (res.products[0]?.isDefaultPkg) {
              //   dispatch(resetPackages())
              // }
              // else {
              dispatch(setInitialPackages(packagesCmtoFt(item1.pkgs)))
              // }

            }
          }
        })
        res?.products[0]?.combination.map((lItem, lIndex) => {
          if (lItem.url === comb[0].url) {
            dispatch(setReferencePackage(packagesCmtoFt(lItem?.lowestPkgs)))
          }
        })
      }
      else {
        if (res?.products[0]?.vendors?.[0]?.sellerWeightChangeSts === "T_PENDING") {
          fetchPendingWeightPackages(allOrders[index].product)
        }
        else {
          // if (res?.products[0]?.isDefaultPkg) {
          //   dispatch(resetPackages())
          // }
          // else {
          dispatch(setInitialPackages(packagesCmtoFt(res?.products[0]?.pkgs)))
          // }
        }
        setVerTrPrice(res?.products[0]?.vendors?.[0]?.purchase_price)
        setCurrentStock(res?.products[0]?.vendors?.[0]?.stock)
        setWeightChangeStatus(res?.products[0]?.vendors?.[0]?.sellerWeightChangeSts)
        dispatch(setReferencePackage(res?.products[0]?.lowestPkgs))
      }
      setVerifyManifestPopup(true)
    }).catch(err => console.log(err))
  }

  const fetchPendingWeightPackages = (product, url = null) => {
    api.product.getSellerWeightChangePendingReq({ "product": product, "pkg.url": url }).then((res) => {
      dispatch(setInitialPackages(packagesCmtoFt(res?.data?.pkgs)))
    })
  }

  const verManifestValidation = {
    step0: () => {
      if (verTrPrice === undefined || verTrPrice === null || verTrPrice < 1) {
        alert.info('Please enter a valid transfer price.')
        return false;
      }
      return true;
    },
    step2: () => {
      if (currentStock !== undefined && currentStock !== null && currentStock !== "") {
        if (Number(currentStock) < 0) {
          alert.info('Please enter a valid stock value.')
          return false;
        }
      }
      return true;
    }
  }

  const verSubmitTPrice = () => {
    const isValid = verManifestValidation.step0()
    if (isValid) setCurrentStep(1)
  }

  const handleVerPackageSubmission = (packages) => {
    if(currentClickedOrder?.order?.products[0]?.sellerWeightChangeSts && checkIsPkgMediaNotPresent(packages)){
            alert.info("Please add at least one image to update package details.")
            return;
    }
    submitVerifyManifest()
  }

  // update seller weight change sts
  const updateSellerWeightChangeSts = async (status) => {
    let data = {
      product: currentClickedOrder?.product,
      sellerWeightChangeSts: status,
    };

    if (currentClickedOrder?.order?.products[0]?.selSubPrd?.url) {
      data["url"] = currentClickedOrder?.order?.products[0]?.selSubPrd?.url
    }
    await api.product.sellerWeightChangeStsUpdate(data);
  }

  const handleAcceptPackage = () => {
    setAcceptPackageSelected(true)
    handleVerPackageSubmission()
  }

  // l1-2110
  // download manifest on tv weight acceptance 
  async function downloadManifest() {
    const invoices = currentClickedOrder?.order?.products[0]?.tracks[0]
    const orderMainId = currentClickedOrder?.order?._id
    const currOrderId = currentClickedOrder?.order?.orderId + currentClickedOrder?.order?.products[0]?.productId?.SKU + '.pdf'
    if (currentClickedOrder?.status === "ASSIGN" || currentClickedOrder?.status === "DOWNLOAD") {


      if (invoices.shippingBy === "ROCKET BOX" || invoices.shippingBy === "ROCKETBOX-MANUAL") {
        downloadManifestPdf();
        api.order.rocketBoxManifest({ _id: orderMainId }).then((res) => {
          console.log(res)

          const link = document.createElement('a');
          link.href = res.data.label_url;
          link.setAttribute('download', currOrderId);
          document.body.appendChild(link);
          link.click();

        }).catch((error) => {
          console.error('Error downloading manifest:', error);
        });
      }
      else if (invoices.shippingBy === "SHIPROCKET") {
        downloadManifestPdf();
        const link = document.createElement('a');
        link.href = invoices.label_url;
        link.setAttribute('download', currOrderId);
        document.body.appendChild(link);
        link.click();


      }
      else {
        downloadManifestPdf();
      }
    }
    else {
      axios({
        url: invoices,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        if (response.status === 200) {
          const newurl = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = newurl;
          // downloadName = url.slice(77);
          link.setAttribute('download', currOrderId);
          document.body.appendChild(link);
          link.click();
          window.open(response.config.url, '_blank');
        }
      }).catch((err) => console.log(err))
    }


    if (currentClickedOrder?.status === "ASSIGN") {

      let data = {
        "_id": currentClickedOrder?._id,
        "status": "DOWNLOAD",
        "platform": 'WEB'
      }
      api.order.updateOrder(data).then((res) => {
      }).catch(err => console.log(err))
    }
  }

  const downloadManifestPdf = () => {
    const invoices = currentClickedOrder?.order?.products[0]?.tracks[0]
    const currOrderId = currentClickedOrder?.order?.orderId + currentClickedOrder?.order?.products[0]?.productId?.SKU + '.pdf'
    axios({
      url: invoices.invoice,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      if (response.status === 200) {
        console.log(response)
        const newurl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = newurl;
        // downloadName = url[i].invoice.slice(77);

        link.setAttribute('download', currOrderId);
        document.body.appendChild(link);
        link.click();
        window.open(response.config.url, '_blank');
        // ele.setAttribute("class", "bi bi-arrow-down-circle-fill download-Manifest-btn");
      }
    }).catch((err) => console.log(err))
  }



  const submitVerifyManifest = async () => {
    // const isValidStep1 = verManifestValidation.step0()
    // if (!isValidStep1) return
    // const isValidStep2 = verManifestValidation.step2()
    // if (!isValidStep2) return
    let isAnyUpdate = false;
    try {
      // 0
      // if (Number(verTrPrice) !== Number(currentClickedOrder?.order?.products[0].purchase_price)) {
      //   let tpData = {
      //     product: currentClickedOrder?.product,
      //     price: verTrPrice,
      //     url: currentClickedOrder?.order?.products[0]?.selSubPrd?.url ? currentClickedOrder?.order?.products[0]?.selSubPrd?.url : null
      //   }
      //   await api.transferprice.priceChangeRquest(tpData)
      //   isAnyUpdate = true
      // }
      // 1
      if (currentClickedOrder?.order?.products[0]?.sellerWeightChangeSts !== "V_ACTIVE" && currentClickedOrder?.order?.products[0]?.sellerWeightChangeSts !== "T_ACTIVE") {
        if (acceptPackageSelected || arePackagesEqual(packages, initialPackages)) {
          await updateSellerWeightChangeSts("V_ACTIVE")
          isAnyUpdate = true
          downloadManifest()
        }
        else {
          let pkgData;
          pkgData = {
            orderId: currentClickedOrder?.order?.orderId,
            product: currentClickedOrder?.product,
            status: "T_PENDING",
            pkg: currentClickedOrder?.order?.products[0]?.selSubPrd?.url ? { url: currentClickedOrder?.order?.products[0]?.selSubPrd?.url, pkgs: dimensionUnit === "ft" ? packagesFttoCm(packages) : packages } :
              { productName: currentClickedOrder?.order?.products[0]?.productId?.productName, pkgs: dimensionUnit === "ft" ? packagesFttoCm(packages) : packages },
            categories: currentClickedOrder?.order?.products[0]?.productId?.categories,
            requestType: "EXISTING_PRODUCT"
          };
          const sanitizedPkgData = sanitizePkgImages(pkgData);
          await api.product.saveSellerWeightChangeReq(sanitizedPkgData)
          isAnyUpdate = true
        }
      }
      // 2
      // if (Number(currentStock) !== Number(currentClickedOrder?.stock)) {
      //   let stockData = {
      //     _id: currentClickedOrder?.product,
      //     stock: currentStock,
      //     url: currentClickedOrder?.order?.products[0]?.selSubPrd?.url ? currentClickedOrder?.order?.products[0]?.selSubPrd?.url : null
      //   }
      //   await api.product.addToExProduct(stockData)
      //   isAnyUpdate = true
      // }
      if (isAnyUpdate) {
        getOrders()
        alert.success("updated")
      }
      setCurrentStep(1)
      setVerifyManifestPopup(false)
      setWeightChangeStatus(null)
    } catch (err) {
      alert.error(err)
    }
  }

  const handleModalGoBack = (step) => {
    console.log(step, currentStep)
    if (step < currentStep) {
      setCurrentStep(step)
    }
  }

  const handlePackageRequestReject = () => {
    setRejectPackageSelected(true)
  }

  const styles = {
    verifyManifestPopup: {
      headerDiv: {
        display: 'flex',
        width: '100%'
      },
      headerBtns: {
        flex: 1,
        border: 'none',
        boxShadow: '0px 1px 0px 0.5px grey',
        padding: '4px 0px',
        fontSize: "14px"
      },
      vtpPara: {
        textAlign: 'left',
        fontSize: '16px',
      },
      imageBox: {
        height: "98px"
      },
      pName: {
        textAlign: 'left',
        fontSize: '16px',
      },
      sku: {
        textAlign: 'left',
      },
      confirmBtn: {

      },
      label: {
        display: 'flex',
        justifyContent: 'center'
      },
      tpInput: {
        width: '100%',
        padding: '2px 15px 2px 12%',
        fontWeight: 'bold',
        letterSpacing: '0.5px'
      },
      rsLabel: {
        position: 'absolute',
        top: '3px',
        left: '5%',
        // fontWeight:'800 !important'
      },
      tpTitle: {
        color: 'black',
      },
      sUpdateContainer: {
        position: 'relative',
        textAlign: 'center',
      },
      cStockTitle: {
        position: 'absolute',
        transform: 'translateY(-50%)',
        top: '0px',
        marginLeft: '12px',
        zIndex: 1,
        padding: '0px 4px',
        background: 'white',
      },
      cStockInput: {
        padding: '4px 15px 4px 10px',
        fontSize: '14px'
      },
      endBtnContainer: {
        textAlign: 'end',
        marginTop: '40px'
      },
      submitBtn: {
        color: '#fff',
        background: '#165b5b',
        borderRadius: '4px',
        padding: "4px 20px",
        borderStyle: 'none',
        fontSize: '13px',
        boxShadow: '0 .2em 1em -.2em #d0d0d0'
      },
      backBtn: {
        color: 'white',
        background: '#909090',
        borderRadius: '4px',
        padding: "4px 15px",
        borderStyle: 'none',
        fontSize: '14px',
        boxShadow: '0 .2em 1em -.2em #d0d0d0',
      },
      tpEdit: {
        top: '3px',
        position: 'absolute',
        right: '2px',
        cursor: 'pointer'
      },
      stockEdit: {
        top: '-1px',
        position: 'absolute',
        right: '2px',
        cursor: 'pointer'
      },
    }
  }


  //<Start-Here> Serach Ticket: SL-675
  /**
  * API Calling
  */
  const ApiCalling = (flag) => {
    applyLoader()
    if (globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    globalFilter.pageNo = selectedPage;
    if (flag === "reset") {
      delete globalFilter?.filters?.["product-objectId"];
      globalFilter.pageNo = 1;
      setSelectedPage(1)
    }
    api.order?.orders(filterOrders(globalFilter))
      .then((res) => {
        removeLoader()
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        removeLoader()
        console.log(err)
      })


  }

  
  const hasActiveWrongProductReport = (item) => {
    // Check if there are wrong product reports at order level
    if (item.order?.wrongProductReports && Array.isArray(item.order.wrongProductReports) && item.order.wrongProductReports.length > 0) {
      return true; // ✅ Make sure this line exists!
    }
    return false;
  };

  const getLatestWrongProductReportMessage = (item) => {
    if (item.order?.wrongProductReports && item.order.wrongProductReports.length > 0) {
      // Sort by timestamp and get the latest pending/active report
      const activePendingReports = item.order.wrongProductReports
        .filter(report => report.status === 'PENDING' || report.status === 'ACTIVE')
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

      if (activePendingReports.length > 0) {
        return activePendingReports[0]?.message || 'Product issue reported';
      }
    }

    return '';
  };

    const getWrongProductReportsCount = (item) => {
    if (item.order?.wrongProductReports) {
      return item.order.wrongProductReports.length;
    }

    return item.order?.totalReportsCount || 0;
  };

  /**
  * Search By Keyword On Enter
  */
  const searchByKeyword = (value, type, productIds) => {

    if (productIds.length > 0) {
      applyLoader()
      if (type === "sku") {
        globalFilter['filters'] = { ...globalFilter.filters, "product-objectId": productIds?.[0] }
        if (globalFilter?.searchIds)
          delete globalFilter['searchIds'];
      }
      else {
        globalFilter['searchIds'] = productIds
      }
      //Search Issue on Other than 1st Page SL-698 and SL-675
      globalFilter.pageNo = 1;
      setSelectedPage(1);
      api.order?.orders(filterOrders(globalFilter))
        .then((res) => {
          removeLoader()
          setallOrders(res.data)
          setallRecords(res.totalRecords)
        }).catch(err => {
          removeLoader()
          console.log(err)
        })


    }
    else {
      setallOrders([]);
      setallRecords(0);

    }
  }
  //</End-Here> Serach Ticket: SL-675

  return (
    <>
      {alertshow === true ?
        <Alert variant="success" className="Myalert" style={{ "backgroundColor": alertType }} onClose={() => setalertShow(false)} dismissible>
          <Myalert
            message={alertMessage}
          />
        </Alert> : <></>
      }

      <div className="" id="orDeskContain">
        <div className='d-flex mb-3 justify-content-start'>
          {/* ******** */}
          <div className='theme-shed1 p-2'>
            <div className='m-auto mt-1'>
              <span className='payment_dates'>From: - <input type='date' min={minValDate} max={sortHistdateto || undefined} value={sortHistdatefrom} onChange={(e) => setdateweb(e, "from")}></input></span>
              <span className='mx-2 payment_dates'>To: - <input type='date' min={sortHistdatefrom || minValDate || undefined} value={sortHistdateto} onChange={(e) => setdateweb(e, "to")} max={moment().format('YYYY-MM-DD')}></input></span>
              <span><button className='apply-btn px-3 py-1 ff_Pop fs-14' onClick={() => applyFilter()}>Apply</button></span>
              {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilters()}>Clear</button></span> */}
            </div>
          </div>
          {/* ****** */}
        </div>

        {/* New orders desktop */}
        <div class="tab mx-2 table-responsive">
          <table className='ord_table new-table-design' style={{ "width": "100%" }}>
            <thead>
              <tr className='table_ord_title_row'>

                <th className='thead_title' style={{ "width": "7%" }}>Order ID
                  <br></br>
                  <input type="text" value={orderId} name="name" placeholder='Search' className='w-90 order_table_srch_input' onChange={(e) => setOrderId(e.target.value)} onKeyUp={(e) => checkevent(e, "id")} />
                  <i class="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({ keyCode: 13 }, "id")}></i>
                </th>

                <th className='thead_title pb-1' style={{ "width": "7%" }}>Date<br></br>
                </th>

                <th className='thead_title' style={{ "width": "10%" }}>Product image</th>

                <th className='thead_title' style={{ "width": "20%" }}>Product Name & SKU
                  <br />
                  <OrderSKUSearch
                    filterSearch={filterSearch}
                    searchNewEnq={setorderName}
                    from={"orders"}
                    flag="Order" // set flag
                    apiCall={ApiCalling}
                    data="filedData"
                    totalRcordId={totalRcordId}
                    searchByKeyword={searchByKeyword}
                    apiurl="searchSellerOrdersFilter"
                    ordersSearchParam={filterOrders(globalFilter)}
                  />
                </th>

                <th className='thead_title' style={{ "width": "10%" }}>Transfer price</th>
                {/* {stateData?.addresses?.data?.length > 0 && */}
                <th className='thead_title' style={{ "width": "10%" }}>Pickup Address
                  {/*<Start-Here> Pickup Address Dropdown | Ticket : SL-923 */}
                  {/* SL-1218 */}
                  {stateData?.addresses?.data?.length > 0 && <div className="dropdown-wrapper">
                    <select
                      value={addressName}
                      onChange={(e) => {
                        const value = e.target.value;
                        setAddressName(value);
                        //Immediately trigger search after selection
                        checkevent({ keyCode: 13 }, "address", value);
                      }}
                    >
                      <option value="">All</option>
                      {stateData?.addresses?.data.map((address) => (
                        <option key={address._id} value={address.firstName}>
                          {address.firstName}
                        </option>
                      ))}
                    </select>
                  </div> }
                  {/*</End-Here> Pickup Address Dropdown | Ticket : SL-923 */}
                  {/*<input type="text" value={addressName} name="name" id="inputnameweb" placeholder='Search..' className='w-95 order_table_srch_input' onChange={(e) => setAddressName(e.target.value)} onKeyUp={(e) => checkevent(e, "address")} />
                  <i className="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({ "keyCode": 13 }, "address")}></i>*/}
                </th>
                <th className='thead_title' style={{ "width": "4%" }}>Total package</th>
                
                <th className='thead_title' style={{ "width": "8%" }}>Logistics</th>

                <th className='thead_title' style={{ "width": "20%" }}>Order Status
                  <br></br>
                  <select id="dropdown" className='drop-button' value={currwebFilt} onChange={(e) => setstatusfilterWeb(e.target.value)}>
                    <option value="0" className='ff_pop'>All Orders</option>
                    <option value="1" className='ff_pop'>Fresh Orders</option>
                    <option value="2" className='ff_pop'>Downloaded</option>
                    <option value="3" className='ff_pop'>Cancelled</option>
                    <option value="4" className='ff_pop'>Shipped</option>
                    <option value="5" className='ff_pop'>Delivered</option>
                    <option value="6" className='ff_pop'>Revoked</option>
                    <option value="7" className='ff_pop'>Partially delivered/RTO</option>
                    <option value="8" className='ff_pop'>Partially delivered/Lost</option>
                    <option value="9" className='ff_pop'>Lost</option>
                  </select>
                </th>
              </tr>

            </thead>
            <tbody>
              {allOrders.length > 0 ? allOrders.map((item, index) => {
                let baseImg;
                let date = new Date(item.createdAt);
                let d = date.toUTCString(item.createdAt);
                let newd = d.substr(4, 12)
                let delivDate = new Date(item.updatedAt)
                let delDate = delivDate.toUTCString(item.updatedAt)
                let newDelDate = delDate.substr(4, 12)
                let update = new Date(item.updatedAt);
                let upd = update.toUTCString(item.updatedAt);
                let upnewd = upd.substr(4, 12)
                let orderPlaceDate = new Date(item?.order?.orderPlaceDate);
                let orderPlace = orderPlaceDate.toUTCString(item?.order?.orderPlaceDate);
                orderPlaceDate = orderPlace.substr(4, 12)
                if (item?.order?.products.length > 0) {
                  item.order?.products[0].productId.images.map((item) => {
                    if (item.baseImage === true) {
                      if (item.image.startsWith("products")) {
                        baseImg = item.image;
                      }
                      else {
                        let img = item.image.substr("41")
                        baseImg = img;
                      }
                    }
                  })
                  if (item.order?.products[0].selSubPrd && item.order?.products[0].productId.combination) {
                    let showVerifyToGenManifest = true;
                    if (item.order?.products?.[0]?.sellerWeightChangeSts === "T_ACTIVE" || item.order?.products?.[0]?.sellerWeightChangeSts === "V_ACTIVE") {
                      showVerifyToGenManifest = false;
                    }
                    return (
                      <OrderCardWeb id={index}
                        type="New-Orders"
                        nicknameAdd={item.order?.products && item.order?.products[0] && item.order?.products[0].vendorDetails && item.order?.products[0].vendorDetails.addrName ? item.order?.products[0].vendorDetails.addrName : undefined}
                        lead={item._id}
                        key={item._id}
                        downloadManifestToast={downloadManifestToast}
                        updatedAt={upnewd}
                        orderPlaceDate={orderPlaceDate}
                        showVerifyToGenManifest={showVerifyToGenManifest}
                        taxClass={item.order?.products?.[0]?.vendorDetails?.taxClass}
                        sku={item.order?.products[0].productId.SKU}
                        date={newd}
                        orderMainId={item.order?._id}
                        orderId={item.order?.orderId}
                        isWeightVerified={(item.order?.products?.[0]?.sellerWeightChangeSts === "V_ACTIVE" || item.order?.products?.[0]?.sellerWeightChangeSts === "T_ACTIVE") ? true : false}
                        isPriceReq={item.order?.products?.[0]?.isPriceReq}
                        stock={item.order?.products?.[0]?.stock}
                        url={item.order?.products[0].productId.urlKey}
                        productName={item.order?.products[0].productId.productName}
                        price={item.order?.products[0].purchase_price}
                        quantity={item.order?.products[0].quantity}
                        status={item.status}
                        invoices={item.order?.products[0].tracks}                      
                        image={baseImg}
                        orderForwardedToSeller={item.order?.orderForwardedToSeller}
                        popupdetailVis={setpopupVisibilityDetail}
                        popupVisibility={setpopupVisibilitytrackWeb}
                        selSubPrdVal={item.order?.products[0].selSubPrd.value}
                        pdetail={detail}
                        manifestDetailsVerify={manifestDetailsVerify}
                        vendor={item.vendor}
                        revokes={item.order?.products[0].revokes}
                        combination={item.order?.products[0].productId.combination[0].value}
                        isManifestDownloadedFun={isManifestDownloaded}
                        revokeReason={item.revoke}
                        orderCancelReason={item.order?.cancelReason}
                        revokeDate={item.order?.products && item.order?.products[0] && item.order?.products[0].revokeDate || undefined}
                        fun={trackPopupWeb}
                        compo="allOrders"
                        sellerWeightChangeSts={item.order?.products?.[0]?.sellerWeightChangeSts}
                        //Platform Fee Ticket : SL-66
                        platformFee={item.order?.pfFees}
                        // l1-2319 (2-9-25)
                        HSN={item.order?.products?.[0]?.HSN}
                        handleHSNModal={handleHSNModalOpen}
                        orderData={item}
                        //SL-950
                        onTransitFetched={(_id, detail, orderId, trackNo) => {
                          setSelectedPopupId(_id);
                          setSelectedTransitDetail(detail);
                          setselectedtrackOrderWeb(orderId);
                          setselectedTrackwithin(trackNo);
                        }}
                        // Sl-967
                        revokeReasonType={item.order?.products?.[0]?.revokeReasonType}
                        product={item.order?.products?.[0]?.productId}
                        order={item.order}
                        reload={getOrders}
                        hasWrongProductReport={hasActiveWrongProductReport(item)}
                        wrongProductReportMessage={getLatestWrongProductReportMessage(item)}
                        wrongProductReportsCount={getWrongProductReportsCount(item)}
                      />
                    )
                  }
                  else {
                    let showVerifyToGenManifest = true;
                    if (item.order?.products?.[0]?.sellerWeightChangeSts === "T_ACTIVE" || item.order?.products?.[0]?.sellerWeightChangeSts === "V_ACTIVE") {
                      showVerifyToGenManifest = false;
                    }
                    return (
                      <OrderCardWeb id={index}
                        type="New-Orders"
                        key={item._id}
                        downloadManifestToast={downloadManifestToast}
                        nicknameAdd={item.order?.products && item.order?.products[0] && item.order?.products[0].vendorDetails && item.order?.products[0].vendorDetails.addrName ? item.order?.products[0].vendorDetails.addrName : undefined}
                        taxClass={item.order?.products?.[0]?.vendorDetails?.taxClass}
                        lead={item._id}
                        date={newd}
                        orderMainId={item.order?._id}
                        pdetail={detail}
                        showVerifyToGenManifest={showVerifyToGenManifest}
                        updatedAt={upnewd}
                        orderPlaceDate={orderPlaceDate}
                        deliveredOn={newDelDate}
                        isWeightVerified={(item.order?.products?.[0]?.sellerWeightChangeSts === "V_ACTIVE" || item.order?.products?.[0]?.sellerWeightChangeSts === "T_ACTIVE") ? true : false}
                        isPriceReq={item.order?.products?.[0]?.isPriceReq}
                        stock={item.order?.products?.[0]?.stock}
                        manifestDetailsVerify={manifestDetailsVerify}
                        sku={item.order?.products[0].productId.SKU}
                        url={item.order?.products[0].productId.urlKey}
                        popupdetailVis={setpopupVisibilityDetail}
                        revokes={item.order?.products[0].revokes}
                        orderId={item.order?.orderId}
                        orderForwardedToSeller={item.order?.orderForwardedToSeller}
                        productName={item.order?.products[0].productId.productName}
                        price={item.order?.products[0].purchase_price}
                        quantity={item.order?.products[0].quantity}
                        status={item.status}
                        invoices={item.order?.products[0].tracks}
                        isProductPickedFun={productPicked}
                        image={baseImg}
                        revokeReason={item.revoke}
                        orderCancelReason={item.order?.cancelReason}
                        revokeDate={item.order?.products && item.order?.products[0] && item.order?.products[0].revokeDate || undefined}
                        vendor={item.vendor}
                        popupVisibility={setpopupVisibilitytrackWeb}
                        isManifestDownloadedFun={isManifestDownloaded}
                        fun={trackPopupWeb}
                        compo="allOrders"
                        sellerWeightChangeSts={item.order?.products?.[0]?.sellerWeightChangeSts}
                        //Platform Fee Ticket : SL-662
                        platformFee={item.order?.pfFees}
                        // l1-2319 (2-9-25)
                        HSN={item.order?.products?.[0]?.HSN}
                        handleHSNModal={handleHSNModalOpen}
                        orderData={item}
                        //SL-950
                        onTransitFetched={(_id, detail, orderId, trackNo) => {
                          setSelectedPopupId(_id);
                          setSelectedTransitDetail(detail);
                          setselectedtrackOrderWeb(orderId);
                          setselectedTrackwithin(trackNo);
                        }}
                        // Sl-967
                        revokeReasonType={item.order?.products?.[0]?.revokeReasonType}
                        product={item.order?.products?.[0]?.productId}
                        order={item.order}
                        reload={getOrders}                        
                        hasWrongProductReport={hasActiveWrongProductReport(item)}
                        wrongProductReportMessage={getLatestWrongProductReportMessage(item)}
                        wrongProductReportsCount={getWrongProductReportsCount(item)}
                      />
                    )
                  }

                }
                else {

                  return (
                    <OrderCardWeb id={index}
                      type="New-Orders"
                      lead={item._id}
                      key={item._id}
                      orderId={item?.order?.orderId}
                      status="noprodetail"
                    />
                  )
                }

              }) : ennewloader === "none" ? (
                <>
                  <tr className="order-no-results-row">
                    <td colSpan={8} className="order-no-results-cell">No Results Found</td>
                  </tr>
                </>
              ) : null}
              
            </tbody>
          </table>
          {/* </Container> */}

          <div class="d-flex justify-content-center" id="enNewLoader" >
            <div style={{ "display": ennewloader }}>
              <MainLoader/>
            </div>
          </div>

          <PaginationCom
            number={allRecords}
            activ={selectedPage}
            paginate={paginate}
            comp={compforPaginationweb}
          />




        </div>

        {/* Toast */}
        <Toast show={showToast} className="ToastHome" onClose={() => setshowToast(false)}>
          <Toast.Header>
            <strong className="me-auto">Message</strong>
          </Toast.Header>
          <Toast.Body>{toastmsg}.</Toast.Body>
        </Toast>



        {/* Modal Confirmation */}

        <Modal
          show={confirmationState}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered>

          {confirmationFor === "negotiate" ? <ConfirmationModal
            from="negotiate"
            onHide={confirmationBoxHiding}
            selectedId={selectedOrder}
            msg={msgConfirmation}
            responseconfirmationFun={responseConfirmNegotiate}
          /> : <ConfirmationModal
            type={confirmationType}
            onHide={confirmationBoxHiding}
            pId={selectedOrdername}
            selectedId={selectedOrder}
            msg={msgConfirmation}
            responseconfirmationFun={responseconfirmation}
          />}

        </Modal>




        {/* Track detail for web | Ticket : SL-950 */}
        {isPopupTrackVisWeb == 'block' &&
          <div id="popupTrackweb" className={`overlay ${isPopupTrackVisWeb == 'block' ? 'visible' : ''}`} style={{ "display": "block" }}>
            <TrackOrderPopup
              type="New-Orders"
              id={selectedPopupId}
              trackDetail={selectedTransitDetail}
              popupVisibility={setpopupVisibilitytrackWeb}
            />
          </div>}

        <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
          <Popup
            from="newOrder"
            description={productDetail[0].description}
            sdescription={productDetail[0].shortDescription}
            specificationNew={productDetail[0].specificationNew}
            descriptionNew={productDetail[0].descriptionNew}
            name={productDetail[0].productName}
            price={detailPPrice}
            SKU={productDetail[0].SKU}
            popupVisibility={setpopupVisibilityDetail}
            images={productDetail[0].images}
            videos={productDetail[0].videos}
            fixedImage={true}
          />
        </div>
        {/* sl-712 */}

        <Modal
          show={verifyManifestPopup}
          className="updtProPopModal orderManVerModal"
          centered
        >
          {/* <Modal.Header>
            <div style={styles.verifyManifestPopup.headerDiv}>
              <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 0 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(0)}>Step 1</button>
              <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 1 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(1)}>Step 2</button>
              <button style={{ ...styles.verifyManifestPopup.headerBtns, background: currentStep === 2 ? '#c5d6d6' : null }} onClick={() => handleModalGoBack(2)}>Step 3</button>
            </div>
          </Modal.Header> */}
          <Modal.Body className="updtProPopModal_body p_3px">
            <a class="close mt-1" onClick={() => {
              dispatch(resetPackages())
              setVerifyManifestPopup(false)
              setCurrentStep(0)
            }}>
              &times;
            </a>
            <p style={styles.verifyManifestPopup.vtpPara}>{variables.variables.orderModalTitles[currentStep]}</p>
            <Row className="">
              <div className="col-md-3 ">
                <div
                  className="catalog-img-border"
                  style={{
                    ...styles.verifyManifestPopup.imageBox,
                    background: `url(
                    "https://s3.toolsvilla.com/${currentClickedOrder?.order?.products?.[0]?.productId?.images[0]?.image}"
                  )`,
                  }}
                >
                </div>
              </div>
              <div className="col-md-9 py-1">
                <p className="product-name ff_pop" style={styles.verifyManifestPopup.pName}>{currentClickedOrder?.order?.products?.[0]?.productId?.productName}</p>
                <p className="sku" style={styles.verifyManifestPopup.sku}>{currentClickedOrder?.order?.products?.[0]?.productId?.SKU}</p>
                <p className="sku" style={styles.verifyManifestPopup.sku}>{clickedProDets?.manufacturerName}</p>
                <ul className="d-flex ord-crd mb-0">
                  {currentClickedOrder?.order?.products?.[0]?.selSubPrd?.value && currentClickedOrder.order.products[0].selSubPrd.value.map((item, index) => {
                    return (
                      <>
                        <li className="bg-theme  p-1 m-1 text-white fs-11 corner ff_pop">{currentClickedOrder?.order?.products?.[0]?.productId?.combination[0]?.value[index]} - {item}</li>
                      </>
                    )
                  })
                  }
                </ul>
              </div>
            </Row>

            {/* sl- 712 */}
            {/* Verify Transfer Price */}
            {currentStep === 0 && <>
              <Row className="text-center mt-1">
                <div className="col-12 ">
                  <form className="">
                    <label style={styles.verifyManifestPopup.label}>
                      <span className="transfer-price ff_pop my-auto fw-800" style={styles.verifyManifestPopup.tpTitle}>
                        Transfer Price (incl. {currentClickedOrder?.order?.products?.[0]?.vendorDetails?.taxClass}% GST) :
                      </span>
                      <span className="position-relative ms-1">
                        <input
                          type="number"
                          autocomplete="off"
                          minLength="1"
                          value={verTrPrice}
                          style={styles.verifyManifestPopup.tpInput}
                          required
                          disabled={tpDisabled}
                          onChange={(e) => setVerTrPrice(e.target.value)}
                          onWheel={(e) => e.target.blur()}
                        />
                        <span style={styles.verifyManifestPopup.rsLabel}><i className="bi bi-currency-rupee" style={{ fontWeight: 'bold !important' }}></i></span>
                        <span style={styles.verifyManifestPopup.tpEdit}><i className="bi bi-pencil" style={{ fontWeight: 'bold !important' }} onClick={() => setTpDisabled(false)}></i></span>
                      </span>
                    </label>
                  </form>
                </div>
              </Row>

              <p style={styles.verifyManifestPopup.endBtnContainer}>
                <button style={styles.verifyManifestPopup.submitBtn} onClick={() => verSubmitTPrice(1)}>Confirm & Proceed</button>
              </p>
            </>}
            {/* Package Information */}
            {currentStep === 1 && <div className='detail-new'>
              <WeightComponent
                viewOnly={(weightChangeStatus === "T_PENDING" || weightChangeStatus === "T_ACTIVE" || weightChangeStatus === "V_ACTIVE") ? true : false}
                // backButton={"Back"}
                // proceedButton={"Proceed"}
                proceed={() => setCurrentStep(2)}
                handleSubmit={handleVerPackageSubmission}
                handleBackPressWeight={() => setCurrentStep(0)}
                weightRequest={weightChangeStatus === "V_PENDING" ? true : false}
                weightChangeStatus={weightChangeStatus}
                handleAcceptPackage={handleAcceptPackage}
                handlePackageRequestReject={handlePackageRequestReject}
                rejectPackageSelected={rejectPackageSelected}
                showRejectMessage={true}
              />
            </div>}
            {/* Stock Update */}
            {
              currentStep === 2 && <>
                <Row>
                  <div style={styles.verifyManifestPopup.sUpdateContainer} className='col-12'>
                    <span style={styles.verifyManifestPopup.cStockTitle}>Current Stock</span>
                    <span className="position-relative ms-1">
                      <input
                        type="number"
                        value={currentStock}
                        disabled={stockDisabled}
                        onWheel={(e) => e.target.blur()}
                        style={styles.verifyManifestPopup.cStockInput} onChange={(e) => setCurrentStock(e.target.value)} />
                      <span style={styles.verifyManifestPopup.stockEdit}><i className="bi bi-pencil" style={{ fontWeight: 'bold !important' }} onClick={() => setStockDisabled(false)}></i></span>
                    </span>
                  </div>
                </Row>
                <p style={styles.verifyManifestPopup.endBtnContainer}>
                  <button style={styles.verifyManifestPopup.backBtn} onClick={() => setCurrentStep(1)}>Back</button>
                  <button className='ms-2' style={styles.verifyManifestPopup.submitBtn} onClick={() => submitVerifyManifest()}>Confirm & Proceed</button>
                </p>
              </>
            }
          </Modal.Body>
        </Modal>
        {/* HSN Modal l1-2319 (2-9-25) */}
        <HSNModal
          show={showHSNModal}
          handleCloseModal={handleHSNModalClose}
          handleHSNModalOpen={handleHSNModalOpen}
          productData={currentProduct}
          onSave={handleHSNModalSave}
          from="All Orders"
        />
        {/* </End-Here> HSN Modal l1-2319 (2-9-25) */}
      </div>
    </>
  )




}


export default AllOrders;